module.exports = __webpack_public_path__ + "static/img/cjzh-enterpriseCulture.2e61012e.png";